import { useEffect, useState } from 'react';

/**
 * @return {isMobile: boolean, isTablet: boolean, isDesktop: boolean;} based on screen size
 * 
 * @usage
 * const {isMobile, isTablet, isDesktop} = useDetectDevice();
   useEffect(() => {
      if(isMobile) // do something
      if(isTablet) // do something
      if(isDesktop) // do something
   }, [isMobile, isTablet, isDesktop]);
 */

export const useDetectDevice = (): {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
} => {
  const [size, setSize] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowSizeChange = (): void => {
      setSize(window.innerWidth);
    };
    window.addEventListener('resize', handleWindowSizeChange);
    return (): void =>
      window.removeEventListener('resize', handleWindowSizeChange);
  }, []);

  return {
    isMobile: size < 768,
    isTablet: size >= 768 && size <= 1024,
    isDesktop: size > 1024,
  };
};
